// This file was automatically generated from appchart.dialog.documentVitals.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.documentVitals');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.visitNote');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.documentVitals.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form class="el8DialogContainer"><div class="el8FieldSection"><label class="el8label el8FieldShort">Date:</label><div class="el8FieldShortLabelPadding el8TextareaWrap datePickerWrap"><input type="text" class="datePicker" name="collectedDate" /></div></div>');
  el8.template.appchart.visitNote.fieldVitals({showButtons: false, isVitalsHidden: false, patientAge: 0, suppressCustomObservations: true}, output);
  output.append('</form>');
  if (!opt_sb) return output.toString();
};
